export default __webpack_public_path__ + "locales/app.bua.json";